var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 16C7.71669 16 7.47919 15.9042 7.28752 15.7125C7.09585 15.5208 7.00002 15.2833 7.00002 15V9L1.20002 1.6C0.950019 1.26667 0.912519 0.916667 1.08752 0.55C1.26252 0.183333 1.56669 0 2.00002 0H16C16.4334 0 16.7375 0.183333 16.9125 0.55C17.0875 0.916667 17.05 1.26667 16.8 1.6L11 9V15C11 15.2833 10.9042 15.5208 10.7125 15.7125C10.5209 15.9042 10.2834 16 10 16H8.00002ZM9.00002 8.3L13.95 2H4.05002L9.00002 8.3Z",
    fill: "#444746"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.bbfa0801c883768bbbcbb241b4b5866f.svg";
export { ForwardRef as ReactComponent };